export const SAVE_ALL_MAINTENANCES = 'SAVE_ALL_MAINTENANCES'
export const SAVE_MAINTENANCE = 'SAVE_MAINTENANCE'
